import { render, staticRenderFns } from "./excepciones.vue?vue&type=template&id=180366ff&"
import script from "./excepciones.component.ts?vue&type=script&lang=ts&"
export * from "./excepciones.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports